export default class MathMethods {
  round(stringNumber) {
    return parseFloat(stringNumber).toFixed(2);
  }

  getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }
}
